module.exports = __webpack_public_path__ + "img/fi-search.b773e4cf.svg";